interface IOption {
  option: 'contact' | 'pricing' | 'liquidation' | 'general'
}

export const getMediaHeigthCard = ({ option }: IOption): number => {
  switch (option) {
    case 'contact':
      return 200
    case 'pricing':
      return 400
    case 'liquidation':
      return 400
    case 'general':
      return 165
    default:
      return 200
  }
}
